import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import MUIDataTable from 'mui-datatables';
import {
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';

import CustomToolbar from 'components/CustomToolbar/CustomToolbar';
import UpdateSteps from 'components/Processes/UpdateSteps';

import { updateProcessStepCompleted } from 'redux/actions';

const ProcessesTable = (props) => {

  const [rowsSelected, setRowsSelected] = useState([]);
  const [rowsExpanded, setRowsExpanded] = useState([]);

  const [processInfo, setProcessInfo] = useState({});
  const [openStepsModal, setOpenStepsModal] = useState(false);

  const filteredProcesses = useMemo(() => {
    return props.processes.filter(process => process.userId === props.user.standardUsers[props.userTabValue].id);

  }, [props.processes, props.userTabValue, props.user]);

  const tableData = useMemo(() => {
    const initialTableData = [];
    
    for ( let i = 0; i < filteredProcesses.length; i++ ) {
      const process = filteredProcesses[i];
      const salesOrderInfo = props.salesOrders.find(salesOrder => salesOrder.id === process.salesOrderId);
      const productInfo = props.products.find(product => product.id === process.productId);
      initialTableData.push({
        id: process.id,
        displayId: process.displayId,
        salesOrderId: salesOrderInfo.displayId,
        productName: productInfo ? productInfo.name : "",
        endDate: moment(salesOrderInfo.endDate).format('DD/MM/YYYY'),
        steps: process.steps,
        userId: process.userId       
      });
    }

    return initialTableData;

  }, [filteredProcesses, props.salesOrders, props.products]);

  const columns = [
    { label: "ID", name: "id", options: { display: 'excluded' } },
    { label: "Process ID", name: "displayId" },
    { label: "Order ID", name: "salesOrderId"},
    { label: "Product Name", name: "productName"},
    { label: "End Date", name: "endDate" }
  ];

  const onRowSelectionChange = (curr, all, rowsSelected) => {
    setRowsSelected(rowsSelected);
  };

  const onRowExpansionChange = (currentRowsExpanded, allRowsExpanded) => {
    setRowsExpanded(allRowsExpanded.map(row => row.dataIndex));
  };

  const customToolbarSelect = () => {
    return (
      <CustomToolbar
        switchy={4}
        updateSteps={updateSteps}
      />
    )
  };

  const updateSteps = () => {
    setProcessInfo(tableData[rowsSelected[0]]);
    setOpenStepsModal(true);
  };

  const handleStepsModalClose = () => {
    setOpenStepsModal(false);
    setProcessInfo({});
    setRowsSelected([]);
  };

  const completeStep = (isCompleted, processId, id) => {
    if(!isCompleted) {
      props.updateProcessStepCompleted({
        id,
        salesOrderProductId: processId
      });
    }
  };

  const options = {
    filterType: 'checkbox',
    responsive: 'standard',
    rowsSelected,
    rowsExpanded,
    onRowSelectionChange,
    onRowExpansionChange,
    customToolbarSelect,
    download: false,
    print: false,
    filter: false,
    viewColumns: false,
    selectableRows: 'single',
    expandableRows: true,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    isRowExpandable: (dataIndex, expandedRows) => {
      // Prevent expand/collapse of any row if there are 1 rows expanded already (but allow those already expanded to be collapsed)
      if (expandedRows.data.length > 3 && expandedRows.data.filter(d => d.dataIndex === dataIndex).length === 0)
        return false;
      return true;
    },
    renderExpandableRow: (rowData, rowMeta) => {
      const colSpan = rowData.length + 1;
      const processId = rowData[0];
      const rowSteps = tableData.find(process => process.id === processId).steps;
      return (
        <tr>
          { rowSteps.length > 0 ?
          <td colSpan={colSpan}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Step Type</TableCell>
                    <TableCell>Vendor Name</TableCell>
                    <TableCell>Cost</TableCell>
                    <TableCell>Start Date</TableCell>
                    <TableCell>Completed</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rowSteps.map((step) => {
                    const vendorInfo = props.vendors.find(vendor => vendor.id === step.vendorId);
                    return (
                      <TableRow key={step.type}>
                        <TableCell>
                          {step.type}
                        </TableCell>
                        <TableCell>{vendorInfo.name}</TableCell>
                        <TableCell>{step.cost}</TableCell>
                        <TableCell>{moment(step.createdAt).format('DD/MM/YYYY')}</TableCell>
                        <TableCell>
                          <Switch
                            checked={step.completed}
                            onChange={() => completeStep(step.completed, processId, step.id)}
                            color="primary"
                          />
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </td> : null }
        </tr>
      );
    }
  };

  return (
    <React.Fragment>
      <MUIDataTable 
        title={"Process List"}
        data={tableData}
        columns={columns}
        options={options}
      />
      { openStepsModal ?
      <UpdateSteps
        open={openStepsModal}
        processInfo={processInfo}
        vendors={props.vendors}
        closeModal={handleStepsModalClose}
      /> : null }
    </React.Fragment>
  )
};

export default connect (null, {updateProcessStepCompleted}) (ProcessesTable);